import styled from 'styled-components';
import { motion } from 'motion/react';
import { media } from '@styles/breakpoints';

/* ── Hero ─────────────────────────────────────────────────── */

export const HeroSection = styled.section`
  position: relative;
  padding-top: calc(
    ${({ theme }) => theme.layout.headerHeight} + ${({ theme }) => theme.spacing[16]}
  );
  padding-bottom: ${({ theme }) => theme.spacing[20]};
  overflow: hidden;
  background: linear-gradient(
    160deg,
    ${({ theme }) => theme.colors.navy[950]} 0%,
    ${({ theme }) => theme.colors.navy[800]} 60%,
    ${({ theme }) => theme.colors.steel[500]} 100%
  );
`;

export const HeroGrid = styled.div`
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
    circle at 1px 1px,
    rgba(255, 255, 255, 0.06) 1px,
    transparent 0
  );
  background-size: 40px 40px;
  pointer-events: none;
`;

export const HeroGlow = styled.div`
  position: absolute;
  top: -100px;
  right: -100px;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 168, 240, 0.15) 0%, transparent 70%);
  pointer-events: none;
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[5]};
`;

/* ── Filtros ──────────────────────────────────────────────── */

export const FiltersSection = styled.div`
  padding-block: ${({ theme }) => theme.spacing[8]};
  border-bottom: 1px solid ${({ theme }) => theme.semantic.border.subtle};
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const FilterLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.semantic.text.muted};
  margin-right: ${({ theme }) => theme.spacing[1]};
`;

export const FilterButton = styled(motion.button)<{ $active: boolean }>`
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]}`};
  border-radius: ${({ theme }) => theme.radii.full};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  cursor: pointer;
  border: 1px solid
    ${({ $active, theme }) => ($active ? theme.colors.cyan[400] : theme.semantic.border.default)};
  background-color: ${({ $active, theme }) =>
    $active ? `${theme.colors.cyan[400]}18` : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.cyan[400] : theme.semantic.text.tertiary};
  transition: all 0.2s ease;

  @media (hover: hover) {
    &:hover {
      border-color: ${({ theme }) => theme.colors.cyan[400]};
      color: ${({ theme }) => theme.colors.cyan[400]};
    }
  }
`;

/* ── Grid ─────────────────────────────────────────────────── */

export const EventsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[5]};
  padding-block: ${({ theme }) => theme.spacing[12]};
`;

export const EventCardWrapper = styled(motion.div)`
  flex: 1 1 280px;
  height: 360px;

  ${media.desktop} {
    max-width: calc(25% - ${({ theme }) => theme.spacing[4]});
  }
`;

/* ── Empty state ──────────────────────────────────────────── */

export const EmptyState = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[4]};
  padding-block: ${({ theme }) => theme.spacing[20]};
  text-align: center;
`;

export const EmptyIcon = styled.span`
  font-size: 3rem;
  opacity: 0.4;
`;

export const EmptyText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.semantic.text.muted};
`;
